<template lang="html">
	<div class="phone">
		<HeadModule :openTarget="'native/current'"/>
		<div class="phone_module">
			<h3 class="phone_txt">重置密码</h3>
			<ul class="tab">
				<li class="act"><span>手机找回</span></li>
				<li @click="email()"><span>邮箱找回</span></li>
			</ul>
			<div class="phoneModule">

			</div>
			<div class="cellphone">
				<div class="cell_phone">
					<input type="text" placeholder="请输入手机号" id="cell_phone" v-model='phone'>
				</div>
			</div>
			<div class="verification">
				<div class="verification_code">
					<input type="text" placeholder="验证码" id="verification_code" v-model='verification'>
				</div>
				<div class="verification_btn" @click="getVerification()">
					{{content}}
				</div>
			</div>
			<div class="setPassword">
				<input type="password" placeholder="输入新密码（输入6-18位包含大小写及数字的密码）" id="setInput" class="setInput" v-model='setInput'>
				<img src="../assets/image/close.png" alt="" @click="setInputs()">
			</div>
			<div class="affirmPassword">
				<input type="password" placeholder="确认密码" id="affirmInput" class="affirmInput" v-model='affirmInput'>
				<img src="../assets/image/close.png" alt="" @click="affirmInputs()">
			</div>
			<div class="put_in" @click="pFind()">
				<p>立 即 找 回</p>
			</div>
		</div>
	</div>
</template>

<script>
	import utils from '@/utils/utils.js';
	import HeadModule from '@/components/HeadModule'

	export default {
		data() {
			return {
				phone: '',
				verification: '',
				content: '发送验证码',
				totalTime: 60,
				setInput: '',
				affirmInput: '',
			}
		},
		components: {
			HeadModule: HeadModule,
		},
		methods: {
			setInputs() {
				let setInput = document.getElementById('setInput');
				if (setInput.type === "password") {
					setInput.type = "text"
				} else {
					setInput.type = "password"
				}
			},
			affirmInputs() {
				let affirmInput = document.getElementById('affirmInput');
				if (affirmInput.type === "password") {
					affirmInput.type = "text"
				} else {
					affirmInput.type = "password"
				}
			},
			email() {
				this.$router.push({
					path: '/forgetEmail',
					query: {
						id: this.$route.query.id,
					}
				})
			},
			getVerification() {
				if (this.phone == '') {
					utils.showMessage('手机号输入错误')
				} else {
					this.$http({
						url: '/Registered/getPhoneSmsCode',
						method: 'get',
						params: utils.cso({
							phone: this.phone,
							phone_head: 86,
							type: 3,
							client: 'H5'
						})
					}).then((res) => {
						if (res.code == 0) {
							this.content = this.totalTime + 's后重新发送'
							let clock = window.setInterval(() => {
								this.totalTime--
								this.content = this.totalTime + 's后重新发送'
								if (this.totalTime < 0) {
									window.clearInterval(clock)
									this.content = '发送验证码'
									this.totalTime = 60
								}
							}, 1000)
						} else {
							utils.showMessage(res.msg);
						}
					})
				}
			},
			pFind() {
				if (/^1[3|4|5|6|7|8]\d{9}$/.test(this.phone)) {
					if (this.verification != '') {
						if (/^(?![^A-Za-z]+$)(?![^0-9]+$)[\x21-x7e]{6,18}$/.test(this.setInput)) {
							if (this.setInput == this.affirmInput) {
								this.$http({
									url: '/Registered/backPasswordToPhone',
									method: 'post',
									params: {
										phone_head: 86,
										phone: this.phone,
										sms_code: this.verification,
										password: this.setInput,
									},
								}).then((res) => {
									if (res.code == '0') {
										this.$router.push({
											path: '/login',
											query: {
												id: this.$route.query.id,
											}
										})
									} else {
										utils.showMessage(res.msg)
									}
								})
							} else {
								utils.showMessage('两次密码不一致')
							}
						} else {
							utils.showMessage('密码输入有误')
						}
					} else {
						utils.showMessage('验证码输入有误')
					}
				} else {
					utils.showMessage('手机号输入有误')
				}
			},
		}
	}
</script>

<style lang="css" scoped>
	.phone_module {
		padding: 0 15px;
	}

	.phone_txt {
		padding-left: 35px;
		padding-top: 35px;
		font-size: 24px;
		color: #1D2023;
	}

	.tab {
		display: flex;
		justify-content: center;
		font-size: 18px;
	}

	.tab li {
		padding: 45px 16px 40px 16px;
	}

	.tab .act span {
		padding: 5px 0;
		border-bottom: 2px solid #E60020;
	}

	.cellphone {
		height: 60px;
		margin: 0 25px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}

	.cell_phone {
		width: 100%;
	}

	#cell_phone:disabled {
		background: #ffffff;
	}

	.cell_phone input {
		width: 100%;
		line-height: 22px;
		font-size: 16px;
		border: none;
		box-sizing: border-box;
	}

	.verification {
		height: 60px;
		margin: 0 25px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}

	.verification_code input {
		width: 200px;
		line-height: 22px;
		font-size: 16px;
		border: none;
		box-sizing: border-box;
	}

	.verification_btn {
		width: 85px;
		height: 25px;
		border: 1px solid #E50120;
		font-size: 12px;
		color: #E50120;
		text-align: center;
		line-height: 25px;
		border-radius: 5px;
	}

	.put_in {
		background: linear-gradient(#FE405A, #E50101);
		height: 45px;
		line-height: 45px;
		text-align: center;
		color: #ffffff;
		margin-top: 55px;
		border-radius: 40px;
		font-size: 20px;
	}

	/* 设置密码 */
	.setPassword {
		height: 60px;
		margin: 0 25px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}

	.setPassword img {
		margin-left: 10px;
		width: 15px;
	}

	.setInput {
		width: 100%;
		line-height: 22px;
		font-size: 16px;
		border: none;
		box-sizing: border-box;
	}

	.affirmPassword {
		height: 60px;
		margin: 0 25px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}

	.affirmPassword img {
		margin-left: 10px;
		width: 15px;
	}

	.affirmInput {
		width: 100%;
		line-height: 22px;
		font-size: 16px;
		border: none;
		box-sizing: border-box;
	}
</style>
